<script>
	import { scrollTo } from "../utils";

	export let moreLabel = "Mehr anzeigen";
	export let lessLabel = "Weniger anzeigen";
	export let more = false;
	export let scrollToElement = null;
	export let onMore = null;
	export let onLess = null;

	function toggle(e) {
		e.stopPropagation();
		more = !more;

		if (!more && scrollToElement) setTimeout(500, scrollTo(scrollToElement));

		if (more && onMore) onMore();
		if (!more && onLess) onLess();
	}
</script>

<div class="more-less-container">
	<div class="more-less" on:click={toggle}>
		{#if more}
			{@html lessLabel}
		{:else}
			{@html moreLabel}
		{/if}
	</div>
</div>

<style lang="scss">
	.more-less-container {
		position: relative;
		user-select: none;
		cursor: pointer;
		width: fit-content;
		border-radius: 36px;
		background: #43396c;
	}

	.more-less {
		position: relative;
		font-size: 13px;
		font-weight: $bold;
		line-height: 120%; /* 15.6px */
		letter-spacing: 0.13px;
		opacity: 0.8;
		padding: 6px 7px;
	}

	@media (min-width: #{$breakpoint-mobile-l + 1px}) {
		.more-less-container {
			background: none;
		}

		.more-less {
			color: #c5bbce;
			padding: 0px;
		}
	}
</style>
